export enum ConfirmationDialogAction {
	PRIMARY = 'primary',
	SECONDARY = 'secondary'
}
